// extracted by mini-css-extract-plugin
export default {"contentWrapper":"privacy_contentWrapper__N8FKf","content":"privacy_content__lfwsd"};